export const handelOpenModalEditDescGratuity = () => ({
    type: 'OPEN_MODAL_EDIT_DESC_GRATUITY'
});
export const handelCloseModalEditDescGratuity = () => ({
    type: 'CLOSE_MODAL_EDIT_DESC_GRATUITY'
});
export const handelToggleLoaderModalDescGratuity = (status) => ({
    type: 'TOGGLE_LOADER_MODAL_EDIT_ORDER_DESC_GRATUITY', status
});
export const handelChangeOrderDescGratuity = (desc, gratuity) => ({
    type: 'CHANGE_ORDER_DESC_GRATUITY', desc, gratuity
});
export const actionChangeInputsModalEditOrderDescGratuity = (name,value) => ({
    type: "CHANGE_INPUTS_MODAL_EDIT_ORDER_DESC_GRATUITY", name, value
});
export const actionChangeGratuityModalEditOrderDescGratuity = (gratuity) => ({
    type: "CHANGE_GRATUITY_MODAL_EDIT_ORDER_DESC_GRATUITY", gratuity
});